async function enableDevelopmentMocks(): Promise<void> {
    if (import.meta.env.DEV) {
        const loader = await import("@/3514/entities/coaching-chat/mocks").then(m => m)

        await loader.initCoachingChatMswWorker()
    }
}

export { enableDevelopmentMocks }
